import type { LanguageCode } from '@sparted/shared-library/business/types';
import { useMemo } from 'react';
import { UseFormWatch } from 'react-hook-form';

import { BreakingNewsFormValues } from './BreakingNewsForm.hook';

export const useCheckRequiredFields = ({
  watch,
  breakingNewsLanguages,
}: {
  watch: UseFormWatch<BreakingNewsFormValues>;
  breakingNewsLanguages: LanguageCode[];
}) => {
  const { completedLanguages, missingCurrentFields } = useMemo(() => {
    return breakingNewsLanguages.reduce(
      (acc, lang) => {
        const fields = ['description', 'name', 'text'] as const;

        const currentMissingFields = fields.filter((field) =>
          field === 'text' ? watch('isLongText') && !watch(`${field}.${lang}`) : !watch(`${field}.${lang}`),
        );

        if (currentMissingFields.length > 0) {
          acc.missingCurrentFields[lang] = currentMissingFields;
        }

        if (currentMissingFields.length === 0) {
          acc.completedLanguages.push(lang);
        }

        if (!watch('coverMedia')) {
          acc.missingCurrentFields[lang] = [...(acc.missingCurrentFields[lang] || []), 'coverMedia'];
        }

        if (!watch('audiences')) {
          acc.missingCurrentFields[lang] = [...(acc.missingCurrentFields[lang] || []), 'audiences'];
        }

        return acc;
      },
      {
        missingCurrentFields: {} as { [key in LanguageCode]?: string[] },
        completedLanguages: [] as LanguageCode[],
      },
    );
  }, [
    breakingNewsLanguages,
    watch(`description`),
    watch(`name`),
    watch(`isLongText`),
    watch(`text`),
    watch('coverMedia'),
  ]);

  return {
    completedLanguages,
    missingCurrentFields,
  };
};
